import { c as _c } from "react/compiler-runtime";
import React from 'react';
import StandardModal from 'components/consumer/StandardModal';
import avo from 'analytics/avo';
import PropTypes from 'prop-types';
import CtaLink from 'components/essentials/Cta/CtaLink';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
const ProductCardShowroomModal = t0 => {
  const $ = _c(33);
  const {
    data: t1,
    isOpen,
    onClose
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const data = t2;
  let t3;
  if ($[2] !== data?.name || $[3] !== data?.url) {
    t3 = () => {
      avo.ctaClicked({
        text: data?.name,
        targetUrl: data?.url,
        cta: "Retail Store",
        location: "PDP"
      });
      window.open(data?.url, "_blank");
    };
    $[2] = data?.name;
    $[3] = data?.url;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const showroomClicked = t3;
  const t4 = data?.name;
  let t5;
  if ($[5] !== t4) {
    t5 = <h2 className="mb-8">{t4}</h2>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h4 className="text-lg font-bold mb-4">Store Hours</h4>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== data?.hours || $[9] !== data?.name) {
    t7 = data?.hours?.map((hourData, hourDataIndex) => <p className="text-[.8125rem] tracking-[.0187rem] font-bold text-gray-light2 whitespace-nowrap leading-[1.4rem]" key={`${data?.name}-${hourDataIndex}`}>{hourData}</p>);
    $[8] = data?.hours;
    $[9] = data?.name;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <div className="flex justify-start items-start flex-col">{t6}{t7}</div>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <h4 className="text-lg font-bold mb-4">Location</h4>;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = data?.locationUrl;
  const t11 = data?.location;
  let t12;
  if ($[14] !== t10 || $[15] !== t11) {
    t12 = <a className="text-sm text-brand font-bold border-0 cursor-pointer bg-transparent no-underline" href={t10} target="_blank" rel="noreferrer">{t11}</a>;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = data?.calendly;
  let t14;
  if ($[17] !== t13) {
    t14 = <CtaLink size="base" color="brand" styling="solid-button" to={t13} className="mx-0 my-[1.4rem]">Book a Virtual Appointment</CtaLink>;
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== showroomClicked) {
    t15 = <button type="button" className="text-sm text-brand font-bold border-0 cursor-pointer bg-transparent no-underline" onClick={showroomClicked} aria-label="Browse products in Showroom">Browse products on display here</button>;
    $[19] = showroomClicked;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t12 || $[22] !== t14 || $[23] !== t15) {
    t16 = <div className="flex justify-start items-start flex-col pl-8 max-[767px]:pt-8 max-[767px]:px-0 max-[767px]:pb-0">{t9}{t12}{t14}{t15}</div>;
    $[21] = t12;
    $[22] = t14;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t16 || $[26] !== t8) {
    t17 = <div className="flex justify-start items-start max-[767px]:flex-col">{t8}{t16}</div>;
    $[25] = t16;
    $[26] = t8;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== isOpen || $[29] !== onClose || $[30] !== t17 || $[31] !== t5) {
    t18 = <StandardModal className="ProductCardShowroomModal" isOpen={isOpen} theme="light" onClose={onClose}>{t5}{t17}</StandardModal>;
    $[28] = isOpen;
    $[29] = onClose;
    $[30] = t17;
    $[31] = t5;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  return t18;
};
ProductCardShowroomModal.propTypes = {
  isOpen: PropTypes.bool,
  data: PropTypes.object,
  onClose: PropTypes.func
};
export default withBrowserOnly(ProductCardShowroomModal);